import React from 'react'
import InputEditable from '../../../miscellaneous/InputEdit/InputEdit';

const PointsTable = (props) => {
  const getDateString = (date) => `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
  return (
    <div className="content-line">
      <div className="line line-100">
        <table className="table-layers-results">
          <thead>
            <tr>
              <th className="table-column-name no-select">
                {
                  props.content.reduce((pre, cur) => pre && cur.active, true) ?
                    <i className="fas fa-toggle-on state-layer-icon green-color" onClick={() => props.activeAllPuntos(false)} title='Desactivar'></i>
                    :
                    <i className="fas fa-toggle-off state-layer-icon" onClick={() => props.activeAllPuntos(true)} style={{ color: 'gray' }} title='Activar'></i>
                }
              </th>
              <th className="table-column-name no-select">Ícono</th>
              <th className="table-column-name no-select">Fecha</th>
              <th className="table-column-name no-select">Texto</th>
            </tr>
          </thead>
          <tbody>
            {props.content.map((item, index) => (
              <tr key={"row-table-hg-ash-" + index}>
                <td className="table-column-user">{item.active}
                  {item.active ?
                    <i className="fas fa-toggle-on state-layer-icon green-color" onClick={() => props.activePunto(index, false)} title='Desactivar'></i>
                    :
                    <i className="fas fa-toggle-off state-layer-icon" onClick={() => props.activePunto(index, true)} style={{ color: 'gray' }} title='Activar'></i>
                  }
                  <i className="far fa-trash-alt state-layer-icon" onClick={() => props.delete(item.id)} style={{ color: 'red', margin: 'auto 5px' }} title='Eliminar'></i>
                </td>
                <td className="table-column-user"><img src={item.icon} alt='icono' style={{ height: '22px' }} /></td>
                <td className="table-column-user no-select">{getDateString(new Date(item.createdAt))}</td>
                <td className="table-column-user no-select pointer" onDoubleClick={() => props.handlerDobleClick('puntos', index)}>
                  {
                    item.edit ?
                      <InputEditable text={item.text} onAccept={props.accept} onCancel={props.cancel} id={item.id} /> :
                      item.text
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PointsTable;